import { DashboardCockpit } from "@/features/dashboard/components/DashboardCockpit";

export function DashboardPage() {
  return <DashboardCockpit />;
}
